<template>
  <vue-friendly-iframe
    v-bind="$attrs"
    :id="frameId"
    :src="url"
    :className="
      className ? 'cat-iframe helpFrame ' + className : 'cat-iframe helpFrame '
    "
    :crossorigin="crossorigin"
    :target="target"
    :allow="allow"
    :name="name"
    :title="title"
    :sandbox="sandbox"
    @load="loadEvent"
    @iframe-load="iframeloadEvent"
  ></vue-friendly-iframe>
</template>
<script type="text/babel">
import { defineComponent } from "vue";
import VueFriendlyIframe from "@/components/catPageTemplate/vue-friendly-iframe.vue";

export default defineComponent({
  name: "CatIframe",
  components: { VueFriendlyIframe },
  props: {
    url: {
      type: String,
      required: true
    },
    frameId: {
      type: String,
      required: true
    },
    className: String,
    crossorigin: { type: String, default: "anonymous" },
    target: { type: String, default: "_parent" },
    allow: String,
    name: String,
    title: String,
    sandbox: String
  },

  methods: {
    loadEvent: function (e) {
      this.$emit("ui-loaded", e);
    },
    iframeloadEvent: function (e) {
      this.$emit("ui-iframe-loaded", e);
    }
  }
});
</script>
